import { Component } from "react";

import './style.scss';

import { ReactComponent as EyeIC } from '../../assets/icons/eye-ic.svg';

class Input extends Component {

    state = {
        defaultType: this.props.type,
        type: this.props.type
    };

    toggleShowText = () => {
        let state = this.state;
        state.type = state.type !== "text" ? "text" : state.defaultType;
        this.setState(state)
    }

    render() {
        let { type, name, placeHolder } = this.props;

        return (
            <div className={`input-c ${this.props.className || ""}`}>
                <input type={this.state.type || "text"} name={name} placeholder={placeHolder} defaultValue={this.props.value} onChange={this.props.onChange ? (e)=>this.props.onChange(e.target.value) : null} />

                {type === "password"
                    ? <div className="show-bt" onClick={this.toggleShowText}><EyeIC className={this.state.type === "text" ? "active" : null} /></div>
                    : null
                }

            </div>
        )
    }
}

export default Input;